import { _window } from "../../app-constants";
import { IUSStateType } from "./interfaces";

export default {
  CGApiUrl: process.env.REACT_APP_CG_BASE_URL,
  CGPublishableKey: process.env.REACT_APP_CG_PUBLISHABLE_KEY,
  CGProductId: process.env.REACT_APP_CG_PRODUCT_ID,
  CGAffiliatedId: process.env.REACT_APP_CG_AFFILIATED_ID,
  CGRosterUpload:
    process.env.REACT_APP_ENV === "production"
      ? _window?.BFPlugin?.cgt?.CGRosterUploadProduction || process.env.REACT_APP_CG_ROSTER_UPLOAD_URL
      : _window?.BFPlugin?.cgt?.CGRosterUploadStaging || process.env.REACT_APP_CG_ROSTER_UPLOAD_URL,
  CGDatePickerFormat: "MM/dd/y",
};

export const CorporateTravelDocs: { [Key: string]: string } = {
  termsAndConditions:
    _window?.BFPlugin?.cgt?.termsAndConditions || `https://www.battleface.com/en-us/corporate-group-library`,
  noticeAndDisclosure:
    _window?.BFPlugin?.cgt?.noticeAndDisclosure ||
    `https://www.battleface.com/documents/corporate-group-travel-important-notices-and-disclosures.pdf`,
  downloadEmployeeTravelRoster: `https://www.battleface.com/wp-content/uploads/Corporate-Group-Roster_Final.xlsx`,

  rosterContactEmail: _window?.BFPlugin?.cgt?.rosterContactEmail || "corportategroup@battleface.com",
  rosterContactNumberUSA_CANADA: _window?.BFPlugin?.cgt?.rosterContactNumberUSA_CANADA || "+1 (855) 998 2928",
  rosterContactNumberInternational: _window?.BFPlugin?.cgt?.rosterContactNumberInternational || "+1 (571) 500 1540",
};
// US States data
export const usStates: readonly IUSStateType[] = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DC", name: "District of Columbia" },
  { code: "DE", name: "Delaware" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  // { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  // { code: "MO", name: "Missouri" },
  // { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  // { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  // { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  // { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" },
];

export const totalDays = (a: Date, b: Date) => {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};

export const formatPhoneNumber = (value: any) => {
  // Remove all non-numeric characters
  const cleaned = value.replace(/\D/g, "");

  // Format the cleaned number
  const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
  if (match) {
    const part1 = match[1] ? `(${match[1]}` : "";
    const part2 = match[2] ? `) ${match[2]}` : "";
    const part3 = match[3] ? `-${match[3]}` : "";
    return `${part1}${part2}${part3}`;
  }
  return value;
};

export const travelInsuranceInstructions = _window?.BFPlugin?.cgt?.travelInsuranceInstruction || [
  "COVERAGE FOR UP TO 1,000 BUSINESS TRAVELERS FOR UP TO 21 DAYS OF TRAVEL",
  "INCLUDES COVERAGE FOR PRE-EXISTING MEDICAL CONDITIONS",
  "24/7 WORLDWIDE NON-INSURANCE TRAVEL ASSISTANCE",
];
